import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Fragment } from 'react';
import { Big } from 'foundations-components/transitional/components/Big';
import { useWizardProgress } from '../../features/wizard/wizardQueries';
import { H1 } from 'foundations-components/transitional/components/H1';
import { H5 } from 'foundations-components/transitional/components/H5';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const WizardTitle = ({
  isMobile,
  catGroup
}) => {
  const {
    currentStep
  } = useWizardProgress();
  const getTitleText = () => {
    return currentStep === 'category' ? /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "learningCenter.wizard.modal.stepcategory.title",
      options: {
        categoryGroup: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.filtersGroups.${catGroup}`
        })
      }
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.wizard.modal.step${currentStep}.title`
    });
  };
  const getSubTitleText = () => {
    return currentStep === 'initial' && /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.wizard.modal.stepinitial.subtitle`
    });
  };
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [isMobile ? /*#__PURE__*/_jsx(H5, {
      marginBlockEnd: "100",
      children: getTitleText()
    }) : /*#__PURE__*/_jsx(H1, {
      marginBlockEnd: "100",
      children: getTitleText()
    }), /*#__PURE__*/_jsx(View, {
      maxInlineSize: "470px",
      children: /*#__PURE__*/_jsxs("p", {
        children: [!isMobile && /*#__PURE__*/_jsx(Big, {
          children: getSubTitleText()
        }), isMobile && getSubTitleText()]
      })
    })]
  });
};
export default WizardTitle;